import { useSelector } from "react-redux";
import TableCellEdit from "../table/components/TableCellEdit.component";
import logbook from "../../module/logbook";
import { API } from '../../module/logbook/api';
import { Box, Grid } from "@mui/material";
import { OPTIONS_STATUS_LOGBOOK, StatusLogbook } from "../../module/logbook/conf/Data.conf";
import RectangleChip from "../common/RectangleChip.component";
import _ from "lodash";
import SelectCustom from "../form/components/SelectCustom.component";


export const StatusLogbookListEdit = ({ value, onClick }) => {
  const userAuth = useSelector((state) => state?.login?.user);

  return (
    <TableCellEdit
      module={{
        ...logbook,
        query: {
          ...logbook.query,
          edit: { settings: API.updateFromList },
        },
      }}
      value={value}
      defaultValues={{ status_logbook: value?.status_logbook }}
      name={'status_logbook'}
      form={
        <Grid item xs={12} sm={12}>
          <SelectCustom
            id='status_logbook'
            name='status_logbook'
            label='Status'
            options={OPTIONS_STATUS_LOGBOOK?.[userAuth?.department] || OPTIONS_STATUS_LOGBOOK.DEFAULT}
          />
        </Grid>
      }
    >
      {value?.status_logbook ? (
        <Box onClick={onClick}>
          <RectangleChip
            value={value?.status_logbook}
            backgroundColor={_.find(StatusLogbook, (item) => item?.label === value?.status_logbook)?.hex}
            color='#fff'
          />
        </Box>
      ) : (
        '-'
      )}
    </TableCellEdit>
  );
};